/**
 * @generated SignedSource<<b5b2507c1aeb9163d50bfe640016332e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
import { FragmentRefs } from "relay-runtime";
export type appointmentRowPatient_WaitingRoomAppointment$data = {
  readonly appointment: {
    readonly patient: {
      readonly age: {
        readonly days: number;
        readonly months: number;
        readonly weeks: number;
        readonly years: number;
      };
      readonly displayId: number;
      readonly gender: Gender;
    };
  };
  readonly " $fragmentType": "appointmentRowPatient_WaitingRoomAppointment";
};
export type appointmentRowPatient_WaitingRoomAppointment$key = {
  readonly " $data"?: appointmentRowPatient_WaitingRoomAppointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentRowPatient_WaitingRoomAppointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentRowPatient_WaitingRoomAppointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gender",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Age",
              "kind": "LinkedField",
              "name": "age",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "days",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "months",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weeks",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "years",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};

(node as any).hash = "9965d3d7c3cd040f1735747b626ae6cc";

export default node;
